export default __webpack_public_path__ + "static/media/ballColoringSample.7f8b8cecc0ffd7e13b446517fe538840.png";